import {
  VEHICLE_ADD_LOADING_REQUEST,
  VEHICLE_ADDED_FAILED,
  VEHICLE_ADDED_SUCCESS,
  VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST,
  VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS,
  VEHICLE_DELETE_FAILED,
  VEHICLE_DELETE_LOADING_REQUEST,
  VEHICLE_DELETE_SUCCESS,
  VEHICLE_DETAILS_FETCH_FAILED_REQUEST,
  VEHICLE_LIST_FETCH_FAILED,
  VEHICLE_LIST_FETCH_LOADING_REQUEST,
  VEHICLE_LIST_FETCH_SUCCESS,
  EDIT_VEHICLE_DETAILS_REQUEST,
  EDIT_VEHICLE_DETAILS_FAILURE,
  EDIT_VEHICLE_DETAILS_SUCCESS,
  SET_SELECTED_VEHICLE_DETAILS,
} from "../constants";

const INITIAL_STATE = {
  current: {},
  isLoading: false,
  uploadedVehicleImage: null,
  isLoadingImageUpload: false,
  selectedVehicle: {},
};

export const vehicleReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VEHICLE_ADD_LOADING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case VEHICLE_ADDED_FAILED:
      return INITIAL_STATE;
    case VEHICLE_ADDED_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const vehicleDetailsUploadImageReducer = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        isLoadingImageUpload: true,
      };
    case VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        isLoadingImageUpload: false,
        uploadedVehicleImage: action.payload.originalFileUris,
      };
    case VEHICLE_ADDED_FAILED:
      return {
        ...state,
        isLoading: false,
        current: {},
        isLoadingImageUpload: false,
      };
    default:
      return state;
  }
};

export const getVehicleListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VEHICLE_LIST_FETCH_LOADING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case VEHICLE_LIST_FETCH_FAILED:
      return INITIAL_STATE;
    case VEHICLE_LIST_FETCH_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const deleteVehicleReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VEHICLE_DELETE_LOADING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case VEHICLE_DELETE_FAILED:
      return INITIAL_STATE;
    case VEHICLE_DELETE_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
      };
    case VEHICLE_DETAILS_FETCH_FAILED_REQUEST:
      return {
        ...state,
        isLoading: false,
        current: {},
      };
    default:
      return state;
  }
};

export const editVehicleReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EDIT_VEHICLE_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case EDIT_VEHICLE_DETAILS_FAILURE:
      return INITIAL_STATE;
    case EDIT_VEHICLE_DETAILS_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const setSelectedVehicleReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_VEHICLE_DETAILS:
      return {
        ...state,
        selectedVehicle: action.payload,
      };
    default:
      return state;
  }
};
